// @flow
import React, { PureComponent } from 'react';

import DropdownGuest from 'components/fragments/input/DropdownGuest';
import DropdownMatch from 'components/fragments/input/DropdownMatch';

import type { LogeDetailType } from 'types/LogeDetail';

type Props = {
  loge: LogeDetailType,
  onSubmit: (content: Object) => void,
};

type State = {
  selectedMatch: number,
  selectedMatchLabel: string,
  nbPeople: number,
  error: boolean,
};

class LogeDetailForm extends PureComponent<Props, State> {
  state: State = {
    selectedMatch: 0,
    selectedMatchLabel: '',
    nbPeople: 0,
    error: false,
  };

  _totalPrice = () => {
    const { nbPeople } = this.state;
    const { loge: { prix_base } } = this.props;
    const total = prix_base * nbPeople;

    return total === 0 ? prix_base : total;
  }

  _changeNbPeople = (operator: string, newValue: number): void => {
    const { nbPeople } = this.state;
    let newStateValue = nbPeople;
    switch (operator) {
      case '+':
        newStateValue += 1;
        break;
      case '-':
        newStateValue -= 1;
        break;
      default:
        newStateValue = newValue;
        break;
    }

    if (newStateValue >= 0 && newStateValue <= 100) {
      this.setState({ nbPeople: newStateValue });
    }
  }

  isValid = () => {
    const { selectedMatchLabel, nbPeople } = this.state;

    return selectedMatchLabel !== '' && nbPeople > 0;
  }

  _handleSubmit = (event: Event) => {
    const { selectedMatchLabel, nbPeople } = this.state;
    const { onSubmit, loge: { id, title } } = this.props;
    event.preventDefault();

    if (this.isValid()) {
      this.setState({ error: false });
      onSubmit({ match: selectedMatchLabel, people: nbPeople, id, title });
    } else {
      this.setState({ error: true });
    }
  }

  render() {
    const { nbPeople, error } = this.state;
    const { loge } = this.props;
    const loges = [];
    loges.push(loge);

    return (
      <form onSubmit={this._handleSubmit}>
        {error && (
          <div className='box--content separator'>
            <p className='icon--red'>Tous les champs sont obligatoires.</p>
          </div>
        )}
        <div className="box--content separator">
          <p className="ft-h5">Étape 1 - Choix du match</p>
          <DropdownMatch
            id={'match'}
            label={'Séléctionner un match'}
            headTitle={'Match'}
            loges={loges}
            inputChanged={(value: number, label?: string) =>
              this.setState({ selectedMatch: value, selectedMatchLabel: label })
            }
            />
        </div>
        <div className="box--content separator">
          <p className="ft-h5">Étape 2 - Nombre d’invités</p>
          <DropdownGuest
            label={'Invité'}
            headTitle={'Nombre d\'invité'}
            initialValue={nbPeople}
            inputChanged={(value: number) => this.setState({ nbPeople: value })}
            />
        </div>
        <div className="box--content estimation__footer">
          <div className="estimation__price">
            <p className="ft-h6 ft-up ft-black-secondary mb-0 ">à partir de</p>
            <p className="ft-h3 ft-300 ft-expo mb-0">{this._totalPrice()} € HT</p>
          </div>
          <button
            className="btn btn--primary btn--full"
            type="submit"
            disabled={!this.isValid()}>
              Être recontacté
          </button>
        </div>
      </form>
    );
  }
}

export default LogeDetailForm;
